












































































































import Vue from 'vue'
import { Table, TableColumn } from 'element-ui'
import { KeyDict } from '@/types'
import { SrtMetric, Stream, StreamType } from '@/types/streams'
import { srtInputLine } from '@/helpers/statusHelper'
import SubscribeSRTStreams from '@/mixins/SubscribeSRTStreams'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'

interface StreamColumn {
  name: string,
  state: string,
  srtLineStr: string,
  team: string,
  time: string,
  rtt: string,
  mbpsRate: string,
  extra: string
}

export const getTime = ( metrics: SrtMetric ) : string => {
   let r = '?'
   if (metrics?.time !== undefined) {
     r = metrics.time.toString()
   }
   return r
}
export const getRtt = ( metrics: SrtMetric ) : string => {
  let rtt = '?'
  if (metrics?.link?.rtt !== undefined){
    rtt = metrics.link.rtt
  }
  return rtt
}

export const getInputMbpsRate = ( metrics: SrtMetric ) : string => {
  let mbpsRate = '?'
  if (metrics.recv !== undefined && metrics.recv.mbpsRate !== undefined){
     mbpsRate = metrics.recv.mbpsRate
  }
  return mbpsRate
}

export const getOutputMbpsRate = ( metrics: SrtMetric ) : string => {
  let mbpsRate = '?'
  if (metrics.send !== undefined && metrics.send.mbpsRate !== undefined){
    mbpsRate = metrics.send.mbpsRate
  }
  return mbpsRate
}
export const getInputExtra = ( metrics: SrtMetric ) : string => {
  let extra = '?'
  if (metrics.recv !== undefined){
    extra = JSON.stringify(metrics.recv)
  }
  return extra
}

export const getOutputExtra = ( metrics: SrtMetric ) : string => {
  let extra = '?'
  if(metrics.send !== undefined){
    extra = JSON.stringify(metrics.send)
  }
  return extra
}

export default Vue.extend({
  name: 'SRTMonitor',
  mixins: [ SubscribeSRTStreams ],
  computed: {
    streams (): KeyDict<Stream> {
      return this.$store.direct.state.opsmonitor.srtstreams
    },
    inputTableData (): StreamColumn[] {
      const columns: StreamColumn[] = []
      Object.values(this.streams).forEach(stream => {
        if(stream?.srt_info !== undefined && stream.type === StreamType.Broadcast){
          const metrics = stream.srt_metrics ?? {}
          columns.push({
            name: stream.name,
            srtLineStr : srtInputLine(stream),
            state: stream.srt_state ?? 'unknown',
            team: stream.team_id ?? 'no team',
            time: getTime(metrics),
            rtt: getRtt(metrics),
            mbpsRate: getInputMbpsRate(metrics),
            extra: getInputExtra(metrics)
          })
        }
      })
      return columns
    },
    outputTableData (): StreamColumn[] {
      const columns: StreamColumn[] = []
      Object.values(this.streams).forEach(stream => {
        if(stream?.srt_info !== undefined && stream.type === StreamType.Output){
          const metrics = stream.srt_metrics ?? {}
          columns.push({
            name: stream.name,
            srtLineStr : srtInputLine(stream),
            state: stream.srt_state ?? 'unknown',
            team: stream.team_id ?? 'no team',
            time: getTime(metrics),
            rtt: getRtt(metrics),
            mbpsRate: getOutputMbpsRate(metrics),
            extra: getOutputExtra(metrics)
          })
        }
      })
      return columns
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    LeftSidebarLayout
  }
})

